class B2BActivationForm {
    constructor() {
        this.elements = {
            deviceInput: document.querySelector('input[name="properties[Device ID]"]'),
            masterInput: document.querySelector('input[name="properties[Tuner ID]"]'),
            addToCartButton: this.findAddToCartButton(),
            companyAndTunerIdBlock: this.findCompanyAndTunerIdBlock()
        };


        // Get parent wrappers using optional chaining
        this.wrappers = {
            device: this.elements.deviceInput?.closest('.form-control'),
            master: this.elements.masterInput?.closest('.form-control')?.parentElement
        };

        this.product = this.getProductData();
        this.discountCode = this.findB2BActivationCode();

        this.deviceId = this.elements.deviceInput?.value || '';
        this.masterId = this.elements.masterInput?.value || '';
    }

    findAddToCartButton() {
        // Common selectors for Shopify add to cart buttons
        const possibleSelectors = [
            'div > buy-buttons > button'
        ];

        // Find the first matching button
        for (const selector of possibleSelectors) {
            const button = document.querySelector(selector);
            if (button) return button;
        }


        return null;
    }

    init() {
        if (!this.isValidSetup()) {
            return;
        }
        // rename masterInput name property to Master ID
        this.elements.masterInput?.setAttribute('name', 'properties[Master ID]');

        this.clearFormWrappers();

        const deviceSelect = this.createDeviceSelect();

        // Disable the add to cart button initially
        this.setAddToCartButtonState(false);

        this.hideTunerIdBlock();
        this.registerEventListeners();
        this.fetchAndPopulateDeviceIds(deviceSelect);
    }

    setAddToCartButtonState(enabled) {
        if (!this.elements.addToCartButton) return;

        const masterIsValid = this.masterInputIsValid();
        // selected value must not be the same as master value

        // short notation
        let btn = this.elements.addToCartButton;

        if (enabled && masterIsValid) {
            btn.style.display = 'block';
            btn.classList.remove('disabled');
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
            btn.style.background = 'linear-gradient(90deg,#f85e00,#fa0)';
        } else {
            btn.classList.add('disabled');
            btn.style.background = 'linear-gradient(90deg,#f0f0f0,#f0f0f0)';
            btn.setAttribute('aria-disabled', 'true');
            btn.setAttribute('disabled', 'disabled');
        }
    }

    isValidSetup() {
        if (!this.wrappers.device || !this.wrappers.master) {
            console.error('Required form elements not found');
            return false;
        }

        if (!this.isB2BActivation()) {
            console.error('This product is not a b2b activation product');
            return false;
        }

        if (!this.elements.addToCartButton) {
            console.warn('Add to cart button not found, button disabling will be skipped');
            // Continue without button functionality
        }

        return true;
    }

    findB2BActivationCode() {
        if (!this.product || !Array.isArray(this.product.tags)) {
            return '';
        }

        // Find the first tag containing 'b2b-activation'
        return this.product.tags.find(tag => tag.includes('b2b-activation')) || '';
    }

    isB2BActivation() {
        return Boolean(this.discountCode);
    }

    getProductData() {
        // Use global 'product' if available, otherwise check DOM
        if (typeof product !== 'undefined') {
            return product;
        }

        const productElement = document.getElementById('current-product');
        return productElement ? JSON.parse(productElement.textContent) : null;
    }

    clearFormWrappers() {
        this.wrappers.device.innerHTML = '';
        // hide master input
        if (this.elements.masterInput) {
            this.wrappers.master.style.display = 'none';
        }
    }

    createDeviceSelect() {
        const select = document.createElement('select');

        // Copy original input attributes
        if (this.elements.deviceInput) {
            Array.from(this.elements.deviceInput.attributes).forEach(attr => {
                select.setAttribute(attr.name, attr.value);
            });
        }

        // Update classes
        select.classList.remove('is-floating', 'input');
        select.classList.add('select', 'select--native');

        return select;
    }

    registerEventListeners() {
        document.addEventListener('variant:add', () => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
        this.elements.masterInput?.addEventListener('input', (e) => {
            // check if select has value
            const select = this.wrappers.device.querySelector('select');
            const hasValue = select && select.value !== '';

            this.setAddToCartButtonState(hasValue);
        });
    }


    async fetchAndPopulateDeviceIds(selectElement) {
        // Avoid duplicate fetches
        if (this.wrappers.device.getAttribute('data-device-id') === 'fetched') {
            return;
        }

        try {
            const url = `/a/app/dealer/devices-ids/${this.discountCode}`;
            const response = await fetch(url);
            const data = await response.json();

            if (!data.deviceIds || !data.deviceIds.length) {
                return;
            }

            this.populateDeviceSelect(selectElement, data.deviceIds);
            this.finalizeDeviceSelect(selectElement);

            // replace company name and tuner id block
            this.replaceCompanyNameAndTunerId(data.companyName??'', data.tunerId??'');
            if(parseInt(data.tunerId, 16) >= 0x3A000000) {
                this.showTunerIdBlock();
            }

            // Enable add to cart button once we have device IDs
            this.setAddToCartButtonState(true);
            this.wrappers.master.style.display = 'block';

            // Set up device selection change handler
            selectElement.addEventListener('change', (e) => {
                const hasValue = e.target.value !== '';
                this.setAddToCartButtonState(hasValue);
            });

            // Initial state - button should be disabled until a value is selected
            this.setAddToCartButtonState(false);
        } catch (error) {
            console.error('Error fetching device IDs:', error);
        }
    }

    populateDeviceSelect(select, deviceIds) {
        // Add default option
        const defaultOption = this.createSelectOption('', 'Select Device ID', true);
        select.appendChild(defaultOption);

        // Add device options
        deviceIds.forEach(id => {
            const option = this.createSelectOption(id, id, false);
            select.appendChild(option);
        });
    }

    createSelectOption(value, text, isDefault) {
        const option = document.createElement('option');
        option.value = value;
        option.text = text;
        option.disabled = isDefault;
        option.selected = isDefault;
        return option;
    }

    finalizeDeviceSelect(select) {
        if (this.elements.deviceInput) {
            this.elements.deviceInput.required = true;
        }

        this.wrappers.device.appendChild(select);

        // Update label
        const label = this.wrappers.device.closest('label');
        if (label) {
            label.classList.add('required');
            label.innerHTML = 'Device ID *';
        }

        this.wrappers.device.setAttribute('data-device-id', 'fetched');
    }

    masterInputIsValid() {
        this.elements.masterInput.classList.add('input-error');
        this.elements.masterInput.style.borderColor = 'red';

        if (!this.elements.masterInput) {
            return false;
        }
        // length must be equal to 8
        if (this.elements.masterInput.value.length !== 8) {
            return false;
        }
        this.elements.masterInput.value = this.elements.masterInput.value.toUpperCase();

        // value pattern must be equal match 3A[A-F0-9]{6}
        const pattern = /^3A[A-Fa-f0-9]{6}$/i;
        if (pattern.test(this.elements.masterInput.value) === false) {
            return false;
        }
        // value must not be the same as device id
        if (this.elements.deviceInput && this.elements.deviceInput.value === this.elements.masterInput.value) {
            return false;
        }

        this.elements.masterInput.classList.remove('input-error');
        this.elements.masterInput.style.borderColor = 'green';
        return true;

    }

    findCompanyAndTunerIdBlock() {
        // 1. get all nodes with data-block-type="offer"
        // 2. search the %company% and %tunerid% placeholders
        // 3. return the block
        const blocks = document.querySelectorAll('[data-block-type="offer"]');
        for (const block of blocks) {
            if (block.innerHTML.includes('%company%') && block.innerHTML.includes('%tunerid%')) {
                return block;
            }
        }
        // If no block found, return null
        return null;
    }

    replaceCompanyNameAndTunerId(companyName, tunerId) {
        const block = this.elements.companyAndTunerIdBlock;
        if (!block) {
            console.warn('No block found to replace company name and tuner ID');
            return;
        }

        // Replace placeholders with actual values
        block.innerHTML = block.innerHTML.replace('%company%', companyName);
        block.innerHTML = block.innerHTML.replace('%tunerid%', tunerId);
    }

    hideTunerIdBlock() {
        this.elements.companyAndTunerIdBlock.style.display = 'none';
    }
    showTunerIdBlock() {
        if (this.elements.companyAndTunerIdBlock) {
            this.elements.companyAndTunerIdBlock.style.display = 'block';
        }
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new B2BActivationForm().init();
});